export enum AppContext {
  PF = 'pf',
  PJ = 'pj',
  IA = 'ia',
  AR = 'ar',
  UB = 'ub',
}

export enum AppLanguage {
  EN = 'en',
  ES = 'es',
  PT = 'pt',
}

export enum PageStatus {
  LOADING,
  SUCCESS,
  ERROR,
}
